import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { SandboxService } from '../sandbox.service';

export const SANDBOX_CATALOG_QUERY_KEY = ['sandbox', 'catalog'] as const;
export const SANDBOX_SCENARIOS_QUERY_KEY = ['sandbox', 'scenarios'] as const;
export const sandboxScenarioQueryKey = (id: string) =>
	['sandbox', 'scenario', id] as const;

export const useGetSandboxCatalog = (
	options?: Omit<
		UseQueryOptions<Sandbox.Catalog, Error>,
		'queryKey' | 'queryFn'
	>,
) =>
	useQuery({
		queryKey: SANDBOX_CATALOG_QUERY_KEY,
		queryFn: () => SandboxService.getCatalog(),
		refetchOnWindowFocus: false,
		staleTime: 60 * 1000,
		retry: false,
		...options,
	});

export const useGetSandboxScenarios = (
	options?: Omit<
		UseQueryOptions<Sandbox.Scenario[], Error>,
		'queryKey' | 'queryFn'
	>,
) =>
	useQuery({
		queryKey: SANDBOX_SCENARIOS_QUERY_KEY,
		queryFn: () => SandboxService.listScenarios(),
		refetchOnWindowFocus: false,
		retry: false,
		...options,
	});

export const useGetSandboxScenario = (
	id: string | undefined,
	options?: Omit<
		UseQueryOptions<Sandbox.ScenarioDetail, Error>,
		'queryKey' | 'queryFn'
	>,
) =>
	useQuery({
		queryKey: sandboxScenarioQueryKey(id ?? ''),
		queryFn: () => SandboxService.getScenario(id ?? ''),
		enabled: Boolean(id),
		refetchOnWindowFocus: false,
		retry: false,
		...options,
	});
